export enum FetchDocumentActionTypes {
  GET_MEDIA = 'GET_MEDIA',
  GET_FORM = 'GET_FORM',
  GET_ORIGIN_DATA = 'GET_MEDIA',
  GET_CONTACT_DATA = 'GET_MEDIA',
}
